import React from 'react'
import {Text, View, StyleSheet } from '@react-pdf/renderer'

const borderColor = '#7c7f84'
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        borderBottomColor: '#7c7f84',
        backgroundColor: '#47596d',
        color: '#d7f0f0',
        borderBottomWidth: 1,
        alignItems: 'center',
        height: 24,
        textAlign: 'center',
        fontStyle: 'bold',
        flexGrow: 1,
    },
    description: {
        width: '60%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    qty: {
        width: '10%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    rate: {
        width: '15%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    amount: {
        width: '15%'
    },
})

const InvoiceTableHeader = () => (
    <View style={styles.container}>
        <Text style={styles.description}>Description de l'abonnement mensuel</Text>
        <Text style={styles.qty}>Qt</Text>
        <Text style={styles.rate}>PU</Text>
        <Text style={styles.rate}>dont TVA</Text>
        <Text style={styles.amount}>Montant</Text>
    </View>
)

export default InvoiceTableHeader
